import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin, Phone, Mail, ChevronRight } from 'lucide-react';
import logo from '../../images/Skyline-Contractors-final-logo.png';

const Footer = () => {
  return (
    <footer className="bg-skyline-primary text-gray-300 pt-16 pb-8 border-t-[6px] border-skyline-accent relative z-10">
      <div className="container mx-auto px-6 max-w-7xl">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          
          {/* Company Info */}
          <div className="space-y-6">
            <div className="bg-white p-3 rounded-lg inline-block">
              <img src={logo} alt="Skyline Construction" className="h-12 w-auto object-contain" />
            </div>
            <p className="text-sm leading-relaxed text-gray-400">
              Skyline Contractors & Engineers Pvt Ltd is a premier construction firm delivering top-tier infrastructure, commercial, and residential projects with uncompromising quality and safety.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-xl font-bold text-white mb-6 uppercase tracking-wider">Quick Links</h3>
            <ul className="space-y-3">
              {[
                { name: 'About Us', path: '/about' },
                { name: 'Our Projects', path: '/completed' },
                { name: 'Careers', path: '/career' },
                { name: 'Gallery', path: '/PrevGallery' },
                { name: 'Contact Us', path: '/contact' },
              ].map((link) => (
                <li key={link.name}>
                  <Link to={link.path} className="flex items-center gap-2 hover:text-skyline-accent transition-colors group">
                    <ChevronRight size={16} className="text-skyline-accent group-hover:translate-x-1 transition-transform" />
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-xl font-bold text-white mb-6 uppercase tracking-wider">Contact Us</h3>
            <ul className="space-y-4">
              <li className="flex items-start gap-4">
                <MapPin className="text-skyline-accent shrink-0 mt-1" size={24} />
                <span className="text-sm">Amin Colony,<br/>Parbhani 431401.<br/>Maharashtra (India).</span>
              </li>
              <li className="flex items-center gap-4">
                <Phone className="text-skyline-accent shrink-0" size={24} />
                <span className="text-sm">+91-9028965441 <br/> +91-9373675211</span>
              </li>
              <li className="flex items-center gap-4">
                <Mail className="text-skyline-accent shrink-0" size={24} />
                <span className="text-sm">cmd@skyline.org.in<br/>info@skyline.org.in</span>
              </li>
            </ul>
          </div>

          {/* Newsletter */}
          <div>
            <h3 className="text-xl font-bold text-white mb-6 uppercase tracking-wider">Newsletter</h3>
            <p className="text-sm text-gray-400 mb-4">Subscribe to our newsletter for latest updates and news.</p>
            <form className="space-y-3" onSubmit={(e) => e.preventDefault()}>
              <input 
                type="email" 
                placeholder="Email Address" 
                className="w-full bg-skyline-secondary border border-gray-600 rounded-md px-4 py-3 text-white focus:outline-none focus:border-skyline-accent transition-colors"
              />
              <button className="w-full bg-skyline-accent hover:bg-skyline-accentHover text-white font-bold rounded-md px-4 py-3 transition-colors uppercase tracking-wider">
                Subscribe
              </button>
            </form>
          </div>

        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-skyline-secondary flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-sm text-gray-500">
            &copy; {new Date().getFullYear()} Skyline Contractors & Engineers Pvt Ltd. All Rights Reserved.
          </p>
          <div className="flex gap-6 text-sm text-gray-500">
            <Link to="/login" className="hover:text-skyline-accent transition-colors">Admin Login</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
